import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, switchMap } from 'rxjs/operators';

import { IFaq, IFaqOverviewResponseBean } from '../../models';
import { SupportFacade } from '../../services/support/support.facade';
import * as fromActions from './support.actions';
import * as fromReducers from './support.reducer';
import { ErrorHandlerService } from '../../services/error-handler/error-handler.base-service';

@Injectable()
export class SupportEffects {
  public loadFaqs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.LoadFaqs),
      switchMap(() =>
        this.supportFacade.getPublishedFaqs().pipe(
          map((faqs: IFaq[]) =>
            fromActions.LoadFaqsSuccess({
              faqs,
            })
          ),
          catchError((error: Error) => {
            this.errorHandlerService.handleError(
              '(REQUEST ERROR) on support.effects.ts:loadFaqs$:',
              error
            );
            return [fromActions.LoadFaqsFailed({ error })];
          })
        )
      )
    )
  );
  public loadOverviewFaqs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.LoadOverviewFaqs),
      switchMap(() =>
        this.supportFacade.getFaqOverview().pipe(
          map((faqsOverview: IFaqOverviewResponseBean) =>
            fromActions.LoadOverviewFaqsSuccess({
              faqsOverview,
            })
          ),
          catchError((error: Error) => {
            this.errorHandlerService.handleError(
              '(REQUEST ERROR) on support.effects.ts:loadOverviewFaqs$:',
              error
            );
            return [fromActions.LoadOverviewFaqsFailed({ error })];
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<fromReducers.ISupportState>,
    private supportFacade: SupportFacade,
    private errorHandlerService: ErrorHandlerService
  ) {}
}
